import { Box, Flex, Tab, TabList, Tabs, Text } from "@chakra-ui/react";
import MainFooter from "components/Layout/MainFooter";
import BlogLeftArrowIcon from "images/icons/BlogLeftArrowIcon";
import BlogRightArrowIcon from "images/icons/BlogRightArrowIcon";
import { useWindowDimensions } from "lib/windows";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { Controller, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PostList from "../../components/PostList";
import api from "../../store/api";
import { TAGS_BLACK_LIST, BLOG_EN, FILTERED_BLOG_ID } from "constants/blog";

const BlogTopped = ({ toppedPost }) => {
  const router = useRouter();
  return (
    <Box
      pos="relative"
      cursor="pointer"
      onClick={() => {
        delete router.query["post_id_name"];
        router.push({
          pathname: `/blog/${toppedPost.ID}`,
          query: router.query,
        });
      }}
    >
      <Text
        mb="40px"
        fontSize={{ base: "40px", md: "64px" }}
        fontWeight="700"
        lineHeight={{ base: "48px", md: "80px" }}
        color="#333333"
      >
        消息中心
      </Text>
      <Box pos="relative">
        <Box
          borderRadius="16px"
          flex={{ base: "350px", md: "1 1 auto" }}
          paddingBottom={{ base: "100%", md: "50%" }}
          background={`url(${toppedPost.thumbnail}) no-repeat center center`}
          bgRepeat="no-repeat"
          bgSize="cover"
        />
        <Box
          borderRadius="16px"
          pos="absolute"
          w="100%"
          h="100%"
          top="0"
          left="0"
          bg="linear-gradient(180deg, rgba(0, 0, 0, 0.00) 60%, #000 100%)"
        ></Box>
      </Box>
      <Box
        pos="absolute"
        color="#FFFFFF"
        bottom={{ base: "24px", md: "40px" }}
        left={{ base: "18px", md: "40px" }}
        right={{ base: "10px", md: "40px" }}
      >
        <Text fontSize="12px" fontWeight="400" lineHeight="20px">
          {toppedPost.terms?.[0]?.name}
        </Text>
        <Text
          mt="8px"
          fontSize={{ base: "24px", md: "40px" }}
          fontWeight="700"
          lineHeight={{ base: "32px", md: "48px" }}
        >
          {toppedPost.post_title}
        </Text>
        <Text mt="16px" fontSize="14px" fontWeight="400" lineHeight="22px">
          {toppedPost.post_date}
        </Text>
      </Box>
    </Box>
  );
};

const BlogRecent = ({ termIdList, termIdPostList, setTermId }) => {
  return (
    <Box mt={{ base: "40px", md: "80px" }}>
      <Text
        fontSize={{ base: "20px", md: "40px" }}
        fontWeight="700"
        lineHeight={{ base: "38px", md: "48px" }}
        mb={{ base: "16px", md: "40px" }}
      >
        近期新聞
      </Text>
      <Box mb="16px">
        <Tabs
          defaultIndex={0}
          position="relative"
          variant="unstyled"
          onChange={(index) => setTermId(termIdList[index].term_id)}
        >
          <TabList
            wordBreak="keep-all"
            color="#333333"
            fontSize={{ base: "14px", md: "16px" }}
            lineHeight={{ base: "22px", md: "24px" }}
          >
            <Flex flexWrap="wrap">
              {termIdList.map((tag) => (
                <Tab
                  _focus={{}}
                  _selected={{
                    borderBottom: "2px solid #333333",
                  }}
                  py="4px"
                  px="2px"
                  fontWeight="700"
                  mr={{ base: "10px", md: "24px" }}
                  h={{ base: "22px", md: "28px" }}
                  mb={{ base: "12px", md: "0px" }}
                  key={tag.term_id}
                >
                  {tag.name}
                </Tab>
              ))}
            </Flex>
          </TabList>
        </Tabs>
      </Box>

      <PostList data={termIdPostList} />
    </Box>
  );
};

const BlogSpecial = ({ specialList }) => {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const [swiperOption, setSwiperOption] = useState({});
  const [swiperIndex, setSwiperIndex] = useState(0);

  const swiperRef = useRef(null);

  const goToSlide = (index) => {
    swiperRef.current.slideTo(index);
    setSwiperIndex(index);
  };

  useEffect(() => {
    if (width && width > 390) {
      setSwiperOption({
        slidesPerView: 1.2,
        spaceBetween: 24,
      });
    } else {
      setSwiperOption({
        slidesPerView: 1.05,
        spaceBetween: 10,
      });
    }
  }, [width]);
  return (
    <Box
      bg="#333333"
      h={{ base: "558px", md: "812px" }}
      mt={{ base: "20px", md: "40px" }}
    >
      <Box ml={{ base: "20px", md: "15%" }}>
        <Text
          pt={{ base: "40px", md: "80px" }}
          pb={{ base: "16px", md: "40px" }}
          color="#FFFFFF"
          fontSize={{ base: "20px", md: "40px" }}
          fontWeight="700"
          lineHeight={{ base: "28px", md: "48px" }}
        >
          專欄
        </Text>
        <Swiper
          modules={[Controller, Pagination]}
          onSlideChange={(swiper) => {
            setSwiperIndex(swiper.activeIndex);
            swiperRef.current = swiper;
          }}
          onSwiper={(swiper) => {
            setSwiperIndex(swiper.activeIndex);
            swiperRef.current = swiper;
          }}
          ref={swiperRef}
          slidesPerView={swiperOption.slidesPerView}
          spaceBetween={swiperOption.spaceBetween}
        >
          {specialList.map((post) => (
            <SwiperSlide key={post.ID}>
              <Box
                cursor="pointer"
                onClick={() => {
                  delete router.query["post_id_name"];
                  router.push({
                    pathname: `/blog/${post.ID}`,
                    query: router.query,
                  });
                }}
                h={{ base: "350px", md: "500px" }}
                bgImage={`url('${post.thumbnail}')`}
                bgColor="#EEE"
                bgRepeat="no-repeat"
                bgPosition="center"
                bgSize="cover"
                rounded="10px"
                mb={{ base: "20px", md: "0px" }}
                pos="relative"
                mr="10px"
              >
                <Box
                  pos="absolute"
                  bottom="0"
                  left="0"
                  w="100%"
                  p={{ base: "16px", md: "40px" }}
                  rounded="10px"
                >
                  <Text
                    color="#FFFFFF"
                    fontSize={{ base: "24px", md: "40px" }}
                    fontWeight="700"
                    lineHeight={{ base: "32px", md: "48px" }}
                  >
                    {post.post_title}
                  </Text>
                  <Text
                    mt={{ base: "4px", md: "16px" }}
                    color="#FFFFFF"
                    fontSize="14px"
                    fontWeight="400"
                    lineHeight="22px"
                  >
                    {post.post_date}
                  </Text>
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Flex
        mt="40px"
        mx={{ base: "20px", md: "15%" }}
        justify="space-between"
        align="center"
      >
        <Flex>
          {specialList.map((blog, index) => {
            return (
              <Box
                bg={swiperIndex === index ? "white" : "#888"}
                key={blog.ID}
                w="8px"
                h="8px"
                rounded="full"
                mr="8px"
              />
            );
          })}
        </Flex>
        <Flex>
          <Box
            mr="16px"
            cursor="pointer"
            onClick={() => {
              const nextIndex = swiperIndex - 1 <= 0 ? 0 : swiperIndex - 1;
              console.log("nextIndex", nextIndex);
              goToSlide(nextIndex);
            }}
            userSelect="none"
          >
            <BlogLeftArrowIcon
              color={swiperIndex === 0 ? "rgba(255, 255, 255, 0.2)" : "white"}
            />
          </Box>
          <Box
            cursor="pointer"
            onClick={() => {
              const nextIndex =
                swiperIndex + 1 >= specialList.length - 1
                  ? specialList.length - 1
                  : swiperIndex + 1;
              goToSlide(nextIndex);
            }}
            userSelect="none"
          >
            <BlogRightArrowIcon
              color={
                swiperIndex + 1 === specialList.length
                  ? "rgba(255, 255, 255, 0.2)"
                  : "white"
              }
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

const Blog = () => {
  const [termIdList, setTermIdList] = useState([]);
  const [termId, setTermId] = useState(9);
  const [toppedPost, setToppedPost] = useState({});
  const [termIdPostList, setTermIdPostList] = useState([]);
  const [specialList, setSpecialList] = useState([]);

  useEffect(() => {
    Promise.all([api.getPosts({ page: 1 }), api.getPostTerms()]).then(
      (resp) => {
        // 過濾掉無 thumbnail 的文章
        const filteredPosts = resp[0].data.data
          .filter((post) => post.thumbnail !== "" && post.thumbnail)
          .filter((post) => !BLOG_EN.includes(post.ID))
          .filter((post) => !FILTERED_BLOG_ID.includes(post.ID));
        console.log(filteredPosts);
        // 挑出置頂文章
        setToppedPost(filteredPosts[0]);

        // 把優惠專區擺第一，並去除掉不要的 tag
        const tagList = resp[1].data
          .filter((tag) => !TAGS_BLACK_LIST.includes(tag.term_id))
          .sort((a) => (a.term_id === 9 ? -1 : 1));
        setTermIdList(tagList);
      }
    );
  }, []);

  useEffect(() => {
    // TODO: 這裡沒實作分頁，永遠只有第一頁
    api.getPosts({ page: 1, term_id: termId }).then((resp) => {
      const postList = resp.data.data
        .filter((post) => BLOG_EN.indexOf(post.ID) === -1)
        .filter((post) => FILTERED_BLOG_ID.indexOf(post.ID) === -1);
      // 最多只取前 6 筆
      setTermIdPostList(postList.slice(0, 6));
    });
    api.getPosts({ page: 1, term_id: 12 }).then((resp) => {
      setSpecialList(resp.data.data);
    });
  }, [termId]);

  return (
    <>
      <Head>
        <title key="title">
          好文分享/最新消息｜特斯拉 Tesla 出租車，市場最低價｜悠駕 UDRIVE
        </title>
        <meta
          key="description"
          name="description"
          content="現在成為 UDRIVE 會員，租車特斯拉想優惠，折扣最高 65 折"
        />
        <meta
          key="og_title"
          property="og:title"
          content="好文分享/最新消息｜特斯拉 Tesla 出租車，市場最低價｜悠駕 UDRIVE"
        />
        <meta
          key="og_image"
          property="og:image"
          content="https://www.udrive.city/share.jpg"
        />
        <meta
          key="og_url"
          property="og:url"
          content="https://www.udrive.city/blog"
        />
        <meta key="og_type" property="og:type" content="website" />
        <meta
          key="og_description"
          property="og:description"
          content="現在成為 UDRIVE 會員，租車特斯拉想優惠，折扣最高 65 折"
        />
      </Head>
      <Box mx={{ base: "20px", md: "15%" }} mt={{ base: "40px", md: "80px" }}>
        <BlogTopped toppedPost={toppedPost} />
        <BlogRecent
          termIdList={termIdList}
          termIdPostList={termIdPostList}
          setTermId={setTermId}
        />
      </Box>
      <BlogSpecial specialList={specialList} />
      <MainFooter />
    </>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
export default Blog;
